import { Link } from "react-router-dom";

interface VideoCardProps {
  id: number;
  title: string;
  category: string;
  year?: number;
  rating?: number;
  image: string;
  tags?: string[];
  isNew?: boolean;
  quality?: string;
  source?: string;
}

export default function VideoCard({ id, title, category, year, rating, image, tags, isNew, quality, source }: VideoCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg aspect-[4/3] mb-3">
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
        {isNew && (
          <span className="absolute top-3 left-3 px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-xs font-medium whitespace-nowrap">
            新上线
          </span>
        )}
        {quality && (
          <span className="absolute top-3 right-3 px-2 py-0.5 rounded-md bg-background-950/70 text-background-50 text-xs font-medium whitespace-nowrap backdrop-blur-sm">
            {quality}
          </span>
        )}
        <div className="absolute bottom-3 left-3 right-3">
          {rating && (
            <div className="flex items-center gap-1 mb-1">
              <i className="ri-star-fill text-amber-400 text-xs"></i>
              <span className="text-background-50 text-sm font-semibold">{rating}</span>
            </div>
          )}
          {source && (
            <span className="text-background-50/80 text-xs">{source}</span>
          )}
        </div>
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50">
            <i className="ri-play-fill text-2xl ml-0.5"></i>
          </div>
        </div>
      </div>
      <h3 className="text-sm font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors">
        {title}
      </h3>
      <div className="flex items-center gap-2 mt-1.5 flex-wrap">
        {year && <span className="text-xs text-foreground-500">{year}</span>}
        {tags && tags.slice(0, 2).map((tag) => (
          <span key={tag} className="text-xs px-2 py-0.5 rounded-full bg-background-100 text-foreground-600 whitespace-nowrap">
            {tag}
          </span>
        ))}
      </div>
    </Link>
  );
}